const runtimeConfig = window.RUNTIME_CONFIG || {};

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: runtimeConfig.userPoolId || process.env.REACT_APP_COGNITO_USER_POOL_ID || 'YOUR_USER_POOL_ID',
      userPoolClientId: runtimeConfig.userPoolClientId || process.env.REACT_APP_COGNITO_CLIENT_ID || 'YOUR_USER_POOL_CLIENT_ID',
      loginWith: {
        email: true,
      },
    }
  },
  API: {
    baseUrl: runtimeConfig.apiUrl || process.env.REACT_APP_API_URL || ''
  }
};

export default awsConfig;
